import { ConfigProvider } from 'antd';
import 'antd/dist/antd.less';
import React, { useEffect, useState, lazy } from 'react';
import { shallowEqual, Provider, useSelector } from 'react-redux';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';

import { ThemeProvider } from 'styled-components';
import ProtectedRoute from './components/utilities/protectedRoute';
import config from './config/config';
import store from './redux/store';
import { useAuth } from './hooks/useAuth';

import Admin from './routes/admin';
import Auth from './routes/auth';
import Proje from './routes/proje';
import AfetVeriAnalizi from './routes/afetverianalizi';
import Rapor from './routes/rapor';
import './static/css/style.css';

/* dil dosyası, tarih ve saat formatları ve Andt için Tr Config --*/
import moment from 'moment';
import 'moment/locale/tr';
import trTR from 'antd/lib/locale/tr_TR';

import ErrorBoundaryFunc from './ErrorBoundary';

moment.locale('tr');
/* dil dosyası, tarih ve saat formatları ve Andt için Tr Config --*/

const NotFound = lazy(() => import('./container/pages/404'));
const Error = lazy(() => import('./container/pages/Error'));
const CallbackAfterSignComplete = lazy(() => import('./container/eimza/CallbackAfterSignComplete'));

const { themeColor } = config;

function ProviderConfig() {
  const { isAuthenticated } = useAuth();
  const { rtl, topMenu, mainContent } = useSelector((state) => {
    return {
      /* TODO --- BU TARZ REFERANS ALWAYS FALSE DURUMLARINI ÇÖZELİM.. */
      /* Test */
      rtl: state.ChangeLayoutMode.rtlData,
      topMenu: state.ChangeLayoutMode.topMenu,
      mainContent: state.ChangeLayoutMode.mode,
    };
  }, shallowEqual);

  const [path, setPath] = useState(window.location.pathname);

  useEffect(() => {
    let unmounted = false;
    if (!unmounted) {
      setPath(window.location.pathname);
    }
    return () => {
      unmounted = true;
    };
  }, [setPath]);

  return (
    <ConfigProvider direction={rtl ? 'rtl' : 'ltr'} locale={trTR}>
      <ThemeProvider theme={{ ...themeColor, rtl, topMenu, mainContent }}>
        <>
          <Router basename={process.env.PUBLIC_URL}>
            <ErrorBoundaryFunc>
              {!isAuthenticated ? (
                <Routes>
                  <Route path="/CallbackAfterSignComplete" element={<CallbackAfterSignComplete />} />
                  <Route path="/*" element={<Auth />} /> <Route path="/rapor/*" element={<Rapor />} />
                </Routes>
              ) : (
                <Routes>
                  <Route path="/CallbackAfterSignComplete" element={<CallbackAfterSignComplete />} />
                  <Route path="/admin/*" element={<ProtectedRoute path="/*" Component={Admin} />} />
                  <Route path="/proje/*" element={<ProtectedRoute path="/*" Component={Proje} />} />
                  <Route path="/afetverianalizi/*" element={<ProtectedRoute path="/*" Component={AfetVeriAnalizi} />} />
                  <Route path="/*" element={<Auth />} /> <Route path="/rapor/*" element={<Rapor />} />
                  <Route path="/error" element={<Error />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              )}
              {isAuthenticated && (path === process.env.PUBLIC_URL || path === `${process.env.PUBLIC_URL}/`) && (
                <Routes>
                  <Route path="/" element={<Navigate to="/admin" />} />
                </Routes>
              )}
            </ErrorBoundaryFunc>
          </Router>
        </>
      </ThemeProvider>
    </ConfigProvider>
  );
}

function App() {
  return (
    <Provider store={store}>
      <ProviderConfig />
    </Provider>
  );
}

export default App;
